export enum AppPage {
	ROOT = '/',
	INDEX = '/dashboards',
	LOGIN = '/login'
}
